export default __webpack_public_path__ + "static/banner4-b5bcb494b31f28b0e601c7dc4e21ffa6.jpeg";